import { primaryRegularFont, primarySemiBoldFont, theme } from '@noths/polaris-client-ribbons-base';
import { applyKeyframe } from '@noths/polaris-client-styles';
import { css, keyframes } from 'styled-components';

const { responsiveText, spacing } = theme;

const fadeInAnimation = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

export const fadeIn = css`
  animation: ${applyKeyframe(fadeInAnimation)} 400ms linear;
`;

export const arrivesByLabel = css`
  display: block;
  margin: ${spacing.base}px 0 ${spacing.sm}px;
  ${responsiveText.BODY.MD};

  em {
    font-style: normal;
    color: var(--functional-green-base);
  }
`;

export const deliveryOptionsList = css`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const item = css`
  margin: 0;
  border-top: 1px solid var(--neutral-black-10);
  padding: ${spacing.sm}px 0;
  ${primaryRegularFont};
`;

export const optionInfo = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: ${spacing.md}px;
`;

export const optionPrices = css`
  ${responsiveText.BODY.MD};

  [data-price='0'] {
    color: var(--functional-green-base);
  }

  // pre-sale price
  span {
    margin-right: ${spacing.xs}px;
    text-decoration: line-through;
    color: var(--neutral-black-40);
    ${responsiveText.BODY.MD};
  }

  // price when there's a pre-sale price
  span + [data-price] {
    color: var(--functional-red-base);
  }
`;

export const optionHeading = css`
  margin: 0 0 ${spacing.base}px;
  ${responsiveText.BODY.SM};

  b {
    color: var(--neutral-black-base);
  }

  span {
    color: var(--functional-green-base);
    font-weight: 400;
  }
`;

export const optionBody = css`
  margin: 0;
  ${responsiveText.BODY.XS};

  b {
    ${primarySemiBoldFont};
  }
`;

export const freePartnerDelivery = css`
  display: flex;
  align-items: stretch;
  margin: ${spacing.xs}px 0 0 0;
  border-radius: ${spacing.xs}px;
  padding: ${spacing.xs}px;
  color: var(--neutral-black-base);
  background-color: var(--functional-green-10);
  ${primaryRegularFont};
  ${responsiveText.BODY.SM};

  & > span:first-child {
    min-width: 20px;
  }
`;

export const optionPrice = css`
  ${responsiveText.BODY.MD};
  color: var(--optionPriceColor, var(--neutral-black-base));
`;
